import React, { useState, Fragment } from "react";
import Cookies from "universal-cookie";
import { Row, Col, Button, message, notification } from "antd";
import "antd/dist/antd.css";
import SkillChart from "../../components/Charts/SkillChart";
import PieCharts from "../../components/Charts/PieChart/PieCharts";
import BarChart from "../../components/Charts/BarChartContainer";
import "whatwg-fetch";
import Loader from "../../components/Loader";
import GapAnalyse from "./GapAnalysis";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { generalIntl } from "./generalIntl";
import { Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import {
  EmailTaURL,
  PeerInvitationMailURL
} from "./../../modules/emails/endpoints";

function Analysis(props) {
  const cookies = new Cookies();
  let invitationLink;
  let tabs;
  let headline;
  let subheadline;
  let headtext;
  let chart;
  let getChart;
  let secondButtonDisplay;
  let invitationDisplay;

  let isNotDisabled = {};
  const { peer1Name, peer2Name, peer3Name } = props;

  // This switch decides what kind of chart and chart data is being loaded.
  switch (props.type) {
    case "profile":
      if (!cookies.get(`firstTimeTa${props.id}`)) {
        notification["success"]({
          message: generalIntl.notificationHeader[props.language],
          description: generalIntl.notificationBody[props.language],
          duration: 10,
          placement: "bottomLeft"
        });

        cookies.set(`firstTimeTa${props.id}`, true, { path: "/" });
      }

      invitationDisplay = "block";
      chart = (
        <PieCharts data={props.skillChartResult} language={props.language} />
      );
      headline = generalIntl.headline_ta[props.language];
      headtext = generalIntl.headText_ta[props.language];
      tabs = (peer1Name, peer2Name, peer3Name) => [
        { title: { en: "Overview", dk: "Overblik" }, key: "all" }
      ];
      invitationLink = EmailTaURL;
      secondButtonDisplay = "none";
      getChart = function () {
        console.log(document.getElementById("chart_id"), '1')
        return document.getElementById("chart_id");
      };
      break;
    case "twentyfivesections":
      props.drivers.forEach(element => {
        isNotDisabled[element.type] = true;
      });

      invitationDisplay = "none";

      headline = "Transactional Analysis - Drivers";
      chart = (
        <BarChart
          data={props.skillChartResult}
          drivers={props.drivers}
          highlight={props.highlight}
        />
      );
      tabs = (peer1Name, peer2Name, peer3Name) => [
        { title: { en: "Overview", dk: "Overblik" }, key: "all" },
        {
          title: { en: "12 Sections Driver", dk: "12 Sections Driver" },
          key: "twelvesections"
        },
        {
          title: { en: "24 Questions Driver", dk: "24 Questions Driver" },
          key: "twentyfivesections"
        }
      ];
      invitationLink = EmailTaURL;
      secondButtonDisplay = "none";
      getChart = () => {
        console.log(document.getElementById("chart_id"), '2')
        return document.getElementById("chart_id");
      };

      break;
    case "twelvesections":
      props.drivers.forEach(element => {
        isNotDisabled[element.type] = true;
      });

      invitationDisplay = "none";
      headline = "Transactional Analysis (12 sections)";
      tabs = (peer1Name, peer2Name, peer3Name) => [
        { title: { en: "Overview", dk: "Overblik" }, key: "all" },
        {
          title: { en: "12 Sections Driver", dk: "12 Sections Driver" },
          key: "twelvesections"
        },
        {
          title: { en: "24 Questions Driver", dk: "24 Questions Driver" },
          key: "twentyfivesections"
        }
      ];
      getChart = () => {
        console.log(document.getElementById("chart_id"), '2')
        return document.getElementById("chart_id");
      };

      chart = (
        <BarChart
          data={props.skillChartResult}
          drivers={props.drivers}
          highlight={props.highlight}
        />
      );

      secondButtonDisplay = "none";

      break;
    case "360":
      isNotDisabled = props.skillChartResult
        ? props.skillChartResult[0].type
        : {};

      invitationDisplay = "block";
      chart = (
        <SkillChart
          data={props.skillChartResult}
          highlight={props.highlight}
          stroke_Color={"#FFFF"}
          tick_Color={"#FFFF"}
          language={props.language}
          peer1Name={peer1Name}
          peer2Name={peer2Name}
          peer3Name={peer3Name}
        />
      );
      getChart = function () {
        console.log(document, '3')
        return document.getElementById("chartPrint");
      };
      headtext = generalIntl.headText[props.language];
      headline = generalIntl.headline[props.language];
      subheadline = generalIntl.subheadline[props.language];
      tabs = (peer1Name, peer2Name, peer3Name) => [
        { title: { en: "Overview", dk: "Overblik" }, key: "all" },
        {
          title: { en: "Own evaluation", dk: "Egen evaluering" },
          key: "own"
        },
        {
          title: {
            en: peer1Name || "Peer 1",
            dk: peer1Name || "Besvarelse 1"
          },
          key: "peer1"
        },
        {
          title: {
            en: peer2Name || "Peer 2",
            dk: peer2Name || "Besvarelse 2"
          },
          key: "peer2"
        },
        {
          title: {
            en: peer3Name || "Peer 3",
            dk: peer3Name || "Besvarelse 3"
          },
          key: "peer3"
        }
      ];
      invitationLink = PeerInvitationMailURL;

      secondButtonDisplay = peer1Name ? "block" : "none";
      break;
    default:
  }

  //OnSubmit
  const onSubmitMethod = (email, name) => {
    setOpen(false);

    props.sendPeerInvitation(
      email,
      name,

      props.language,
      props.shareUrl,
      invitationLink,
      props.owner
    );

    message.success(
      props.language === "dk" ? "Emailen er sendt!" : "The email has been sent",
      4
    );
  };

  const [highlight, setHighLight] = useState("all");
  const [open, setOpen] = useState(false);

  return (
    <Row className="survey_content_container survey_results_container">
      <Col md={{ span: 12, offset: 6 }} xs={24}>
        <Row gutter={16}>
          <Col md={24} style={{ marginBottom: "20px" }}>
            <h1 style={{ marginBottom: 0 }}>{headline}</h1>
            <p style={{ fontSize: "18px" }}>{subheadline} </p>
          </Col>
          <Col md={24} style={{ marginBottom: "20px" }}>
            <p style={{ textAlign: "left", marginBottom: "30px" }}>
              {headtext}
            </p>
          </Col>
        </Row>
      </Col>
      <Col md={{ span: 12, offset: 6 }} xs={24}>
        <Row>
          <Col md={24} style={{ marginBottom: "20px" }}>
            <div className="survey_results navWide">
              <div className="wideDiv">
                {tabs(peer1Name, peer2Name, peer3Name).map(tab => (
                  <button
                    key={tab.key}
                    className={`survey_results_filter ${props.highlight ===
                      tab.key && "filter_active"}`}
                    onClick={() => props.changeAnalysisTab(tab.key)}
                    disabled={!isNotDisabled[tab.key] && tab.key !== "all"}>
                    {tab.title[props.language]}
                  </button>
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </Col>
      <Col md={{ span: 16, offset: 4 }} xs={24}>
        <Row gutter={16}>
          <Col md={24} style={{ marginBottom: "20px" }}>
            {props.loading ? <Loader invert /> : (
              <div>
                <div id="chart_id">{chart}</div>
                {props.type === '360' && (
                  <Fragment>
                    <div
                      id="chartPrint"
                      style={{
                        position: "absolute",
                        width: 1300,
                        height: 800,
                        left: 0,
                        top: -10000
                      }}>
                      <SkillChart
                        data={props.skillChartResult}
                        highlight={highlight}
                        stroke_Color="#000"
                        tick_Color="#000"
                        language={props.language}
                        peer1Name={peer1Name}
                        peer2Name={peer2Name}
                        peer3Name={peer3Name}
                      />
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        width: 1600,
                        height: 880,
                        left: 0,
                        top: -15000
                      }}
                    >
                      <div style={{ position: "absolute" }} id="gapPrint">
                        <GapAnalyse
                          textColor='black'
                          result={props.skillChartResult
                            .sort((a, b) => b.difference - a.difference)
                            .filter((item, index) => index < 4)}
                          {...props}
                        />
                      </div>
                    </div>
                  </Fragment>
                )}

                <Modal show={open} onHide={() => setOpen(false)}>
                  <Modal.Header closeButton>
                    <Modal.Title>
                      {props.language === "en" ? "Share email" : "Del email"}
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <iframe
                      title="analysis-iframe"
                      style={{ visibility: "hidden" }}
                      width="0"
                      height="0"
                      border="0"
                      name="analysis-iframe"
                      id="analysis-iframe"
                    />

                    <form id="email_form" class="form-horizontal">
                      <p>
                        <label>
                          {props.language === "en" ? "Name" : "Navn"}
                        </label>
                        <input
                          class="form-control"
                          id="name_id"
                          type="text"
                          name="name"
                          required
                        />
                      </p>
                      <p>
                        <label>Email</label>
                        <input
                          class="form-control"
                          id="email_id"
                          type="email"
                          name="email"
                          required
                        />
                      </p>
                      <p class="full">
                        <Button
                          onClick={() =>
                            onSubmitMethod(
                              document.getElementById("email_id").value,
                              document.getElementById("name_id").value
                            )
                          }
                        >
                          {props.language === "en" ? "Share" : "Del"}
                        </Button>
                      </p>
                    </form>
                  </Modal.Body>
                </Modal>

                <div style={{ marginBottom: "20px" }}>
                  <Button
                    onClick={() =>
                      props.printPDFOwn(getChart(), props.language)
                    }
                  >
                    {generalIntl.donwloadOwnButtonText[props.language]}
                  </Button>
                </div>

                <div
                  id="resultsall_button"
                  style={{ display: secondButtonDisplay }}
                  onClick={() =>
                    props.printPDFPeer(
                      document.getElementById("chartPrint"),
                      document.getElementById("gapPrint"),
                      props.language,
                      peer1Name,
                      peer2Name,
                      peer3Name,
                      setHighLight
                    )
                  }
                >
                  <Button>
                    {generalIntl.downloadAllButtonText[props.language]}
                  </Button>
                </div>

                <div
                  style={{
                    display: invitationDisplay,
                    marginTop: "70px",
                    marginBottom: "20px"
                  }}
                >
                  <Button onClick={() => setOpen(true)}>
                    {generalIntl.invitationButtontext[props.language]}
                  </Button>

                  <p style={{ fontSize: "14px" }}>
                    {props.language === "en" ? "or" : "eller"}
                  </p>
                  <p style={{ fontSize: "14px" }} />
                  <CopyToClipboard text={props.shareUrl}>
                    <div
                      style={{
                        display: invitationDisplay,
                        backgroundColor: "transparent",
                        border: "none",
                        textDecoration: "underline",
                        cursor: "pointer"
                      }}
                    >
                      {generalIntl.clipBoardText[props.language]}
                    </div>
                  </CopyToClipboard>
                </div>
              </div>
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default Analysis;



// WEBPACK FOOTER //
// ./src/pages/SurveyResults/Analysis.js